import { createContext, useContext } from "react";

import type { DialogContent } from "./types";

export type DialogControlContextType = {
  closeDialog: () => void;
  openDialog: (content: DialogContent, onClose?: () => void) => void;
};

export const DialogControlContext =
  createContext<DialogControlContextType | null>(null);

export const useDialogControlContext = () => useContext(DialogControlContext);

export type DialogDataContextType = {
  dialogContent: DialogContent | null;
  isOpened: boolean;
  onClose?: () => void;
};

export const DialogDataContext = createContext<DialogDataContextType | null>(
  null,
);
export const useDialogDataContext = () => useContext(DialogDataContext);
